import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {RouterModule, Routes} from '@angular/router';

import {IonicModule} from '@ionic/angular';

import {KontaktePage} from './kontakte.page';
import {TranslateModule} from '@ngx-translate/core';
import {EffectsModule} from '@ngrx/effects';
import {SopiScrollModule} from '../../../sopi/components/sopi-scroll/sopi-scroll.module';
import {KontaktePageUiEffects} from './kontakte.effects.ui';
import {StoreModule} from '@ngrx/store';
import {reducers} from './kontakte.reducer';
import {KontakteEffectsWs} from './kontakte.effects.ws';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {SopiComponentsModule} from '../../shared/sopi-components/sopi-components.module';
import {
    KontaktverwaltungFunktionsbereichKontakteEffects, KontaktverwaltungKontaktAktivEffects,
    KontaktverwaltungKontaktAktivSetzenEffects,
    KontaktverwaltungKontaktAktualisierenEffects,
    KontaktverwaltungKontaktAnlegenEffects,
    KontaktverwaltungKontaktDetailEffects, KontaktverwaltungKontaktEntfernenEffects,
    KontaktverwaltungKontaktExternEffects, KontaktverwaltungKontaktExternSetzenEffects,
    KontaktverwaltungKontaktTelefonAktualisierenEffects,
    KontaktverwaltungKontaktTelefoneEffects,
    KontaktverwaltungKontaktTelefonEntfernenEffects,
    KontaktverwaltungKontaktTelefonHinzufuegenEffects
} from '../../../client-ngrx/kontaktverwaltung';

const routes: Routes = [
    {
        path: '',
        component: KontaktePage,
        data: {title: 'Kontakte verwalten'}
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        TranslateModule,
        StoreModule.forFeature('KontaktverwaltungPage', reducers),
        EffectsModule.forFeature([
            KontaktePageUiEffects,
            KontakteEffectsWs,

            KontaktverwaltungFunktionsbereichKontakteEffects,
            KontaktverwaltungKontaktAktualisierenEffects,
            KontaktverwaltungKontaktAnlegenEffects,
            KontaktverwaltungKontaktAktivSetzenEffects,
            KontaktverwaltungKontaktExternSetzenEffects,

            KontaktverwaltungKontaktAktivEffects,
            KontaktverwaltungKontaktExternEffects,
            KontaktverwaltungKontaktEntfernenEffects,

            KontaktverwaltungKontaktTelefoneEffects,
            KontaktverwaltungKontaktDetailEffects,
            KontaktverwaltungKontaktTelefonEntfernenEffects,
            KontaktverwaltungKontaktTelefonAktualisierenEffects,
            KontaktverwaltungKontaktTelefonHinzufuegenEffects
        ]),
        SopiScrollModule,
        DragDropModule,
        SopiComponentsModule.forRoot()
    ],
    declarations: [KontaktePage],
    entryComponents: [KontaktePage],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class KontaktverwaltungPageModule {
}
